var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.5835 16.8932H11.9168L7.83765 19.6066C7.23265 20.0099 6.41683 19.5791 6.41683 18.8457V16.8932C3.66683 16.8932 1.8335 15.0599 1.8335 12.3099V6.8099C1.8335 4.0599 3.66683 2.22656 6.41683 2.22656H15.5835C18.3335 2.22656 20.1668 4.0599 20.1668 6.8099V12.3099C20.1668 15.0599 18.3335 16.8932 15.5835 16.8932Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 11.1016C10.6243 11.1016 10.3127 10.7899 10.3127 10.4141V10.2216C10.3127 9.15826 11.0918 8.63575 11.3851 8.43409C11.7243 8.20492 11.8343 8.04909 11.8343 7.81076C11.8343 7.35243 11.4585 6.97656 11.0002 6.97656C10.5418 6.97656 10.166 7.35243 10.166 7.81076C10.166 8.18659 9.85435 8.49826 9.47852 8.49826C9.10268 8.49826 8.79102 8.18659 8.79102 7.81076C8.79102 6.59159 9.78099 5.60156 11.0002 5.60156C12.2193 5.60156 13.2093 6.59159 13.2093 7.81076C13.2093 8.85576 12.4393 9.37824 12.1552 9.57074C11.7977 9.80908 11.6877 9.96493 11.6877 10.2216V10.4141C11.6877 10.7991 11.376 11.1016 11.0002 11.1016Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.3828C10.615 13.3828 10.3125 13.0711 10.3125 12.6953C10.3125 12.3195 10.6242 12.0078 11 12.0078C11.3758 12.0078 11.6875 12.3195 11.6875 12.6953C11.6875 13.0711 11.385 13.3828 11 13.3828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.37294dab7d6e13d08feb0506ba8c403b.svg";
export { ForwardRef as ReactComponent };